var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_setup.componentClasses},[(_vm.icon)?_c(_setup.Icon,{attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.value)?_c('span',{staticClass:"stk-details-title-value"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }